import HeaderBidderConfig from '@/common/models/headerBidder/HeaderBidderConfig';
import OrganizationCustomFieldTypeOptions from '@/common/models/organization-custom-fields/OrganizationCustomFieldTypeOptions';

import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    organizationCustomFields: [],
    newOrganizationCustomField: {}, // Used when creating new report schedules.
  },
  mutations,
  actions,
  getters: {
    organizationCampaignCustomFields: (state) =>
      state.organizationCustomFields.filter(
        (x) =>
          x.type === OrganizationCustomFieldTypeOptions.Campaign.value &&
          !x.key.startsWith(HeaderBidderConfig.customFieldKeysStartsWith),
      ),
    organizationLineItemCustomFields: (state) =>
      state.organizationCustomFields.filter((x) => x.type === OrganizationCustomFieldTypeOptions.LineItem.value),
    organizationDealCustomFields: (state) =>
      state.organizationCustomFields.filter((x) => x.type === OrganizationCustomFieldTypeOptions.Deal.value),
    organizationUnitCustomFields: (state) =>
      state.organizationCustomFields.filter((x) => x.type === OrganizationCustomFieldTypeOptions.Unit.value),
  },
};
